<template>
    <div class="rp-helpdesk-conversation-message-sticker">
        <div class="rp-helpdesk-conversation-message-box-sticker">
            {{ sticker }}
        </div>
    </div>
</template>

<script>

export default {
    
    props: {

        message: {
            type: Object,
            required: true
        }

    },

    computed: {

        sticker() {
            return this.message.mediaValue;
        }

    }

}

</script>

<style lang="scss">

.rp-helpdesk-conversation-message-box-sticker {
    font-size: 80px;
    display: inline-block;
    line-height: 1;

    &.from-operator {
        text-align: right;
    }

    &.from-customer {
        text-align: left;
    }
}

</style>
